/**
 * @generated SignedSource<<9baf83aa86d29e8fba7217a9df17e20e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginJwtInput = {
  base64BrandId: string;
  clientMutationId?: string | null;
  email: string;
  password: string;
};
export type NotLoggedInLoginForm_LoginMutation$variables = {
  input: LoginJwtInput;
};
export type NotLoggedInLoginForm_LoginMutation$data = {
  readonly Auth: {
    readonly loginJwt: {
      readonly jwtTokens: {
        readonly accessToken: string;
        readonly refreshToken: string;
      };
    } | null;
  };
};
export type NotLoggedInLoginForm_LoginMutation = {
  response: NotLoggedInLoginForm_LoginMutation$data;
  variables: NotLoggedInLoginForm_LoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LoginJwtPayload",
        "kind": "LinkedField",
        "name": "loginJwt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JwtLoginInformation",
            "kind": "LinkedField",
            "name": "jwtTokens",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refreshToken",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotLoggedInLoginForm_LoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotLoggedInLoginForm_LoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6eeee57076d756d4647abacf8a63df5c",
    "id": null,
    "metadata": {},
    "name": "NotLoggedInLoginForm_LoginMutation",
    "operationKind": "mutation",
    "text": "mutation NotLoggedInLoginForm_LoginMutation(\n  $input: LoginJwtInput!\n) {\n  Auth {\n    loginJwt(input: $input) {\n      jwtTokens {\n        accessToken\n        refreshToken\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64be9c61269475546af988b82e2bf4c4";

export default node;
